<template>
    <section class="sim-rules" :style="{ '--bg': `url(${ImgSim})` }">
        <header>
            <h1>{{ $t('simRules.hero.title') }}</h1>
            <p>{{ $t('simRules.hero.subtitle') }}</p>
        </header>
        <main>
            <ul class="feature-list">
                <li v-for="feature in features" :key="feature.title">
                    <img :src="icons[feature.icon]" alt="" />
                    <section>
                        <h2>{{ feature.title }}</h2>
                        <p>{{ feature.description }}</p>
                    </section>
                </li>
            </ul>
            <section class="faqs">
                <h2>{{ $t('simRules.faqs.title') }}</h2>
                <ul>
                    <li v-for="(faq,index) in faqs" :key="faq.question">
                        <h3>Q: {{ faq.question }}</h3>
                        <p>A: {{ faq.answer }}</p>
                        <section class="email-subscribe" v-if="index===2">
                            <email-subscription
                                subject="app-reolink-sim-introduction"
                            />
                        </section>
                    </li>
                </ul>
            </section>
        </main>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import IconLink from '@/common/images/common/combo/co_link.svg';
import IconWifi from '@/common/images/common/combo/co_wifi.svg';
import IconReturn from '@/common/images/common/combo/co_return.svg';
import IconGift from '@/common/images/common/combo/co_gift.svg';
import nProgress from 'nprogress';
import ImgSim from 'IMAGE/other/sim.png';
import { config } from 'CONFIG';
import EmailSubscription from '@/components/emailSubscription.vue';

interface IFeature {
    title: string;
    description: string;
    icon: string;
}

interface IFAQ {
    question: string;
    answer: string;
}

export default Vue.extend({
    components: {
        EmailSubscription
    },
    data() {

        return {
            icons: {
                link: IconLink,
                wifi: IconWifi,
                return: IconReturn,
                gift: IconGift
            },
            ImgSim,
            isEmailSubscribeChecked: false,
            email: ''
        };

    },
    computed:{
        features(): IFeature[] {

            return this.$t( 'simRules.features' ) as unknown as IFeature[];

        },
        faqs(): IFAQ[] {

            return this.$t( 'simRules.faqs.items' ) as unknown as IFAQ[];

        },
        config: () => config
    },
    mounted() {

        nProgress.done();

    },
    methods: {
        handleEmailSubscribe() {

            if ( this.isEmailSubscribeChecked && this.email ) {

                // Handle email subscription logic here
                console.log( 'Subscribed with email:', this.email );

            } else {

                console.warn( 'Please agree to the terms and enter a valid email.' );

            }

        }
    }
});
</script>

<style lang="less" scoped>
.sim-rules{
    padding: 45px 16px 35px;
    background-image: var(--bg), linear-gradient(180deg, #D6E2F7 0%, rgba(214, 226, 247, 0) 100%);
    background-repeat: no-repeat;
    background-size: auto 235px;
    background-position: top right;
    header{
        margin-bottom: 32px;
        h1{
            font-size: 28px;
            font-weight: bold;
            line-height: 39px;
            color: @b_6;
        }
        p{
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            margin-top: 3px;
        }
    }
    .card{
        padding: 27px 16px;
        border-radius: 16px;
        background-color: @white;
    }
    .list(@gap){
        display: flex;
        flex-direction: column;
        gap: @gap;
    }
    .feature-list{
        margin-bottom: 16px;
        .card();
        .list(16px);
        li{
            display: flex;
            align-items: flex-start;
            gap: 8px;
            section{
                h2{
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 24px;
                }
                p{
                    font-size: 12px;
                    line-height: 18px;
                    margin-top: 4px;
                }
            }
        }
    }
    .faqs{
        .card();
        h2{
            font-size: 18px;
            font-weight: 600;
            line-height: 27px;
            margin-bottom: 12px;
        }
        ul{
            .list(16px);
            li{
                padding-bottom: 16px;
                border-bottom: 1px solid @line;
                &:last-of-type{
                    border-bottom: none;
                }
                h3{
                    font-size: 14px;
                    line-height: 21px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                p{
                    font-size: 12px;
                    line-height: 18px;
                }
            }
        }
    }
}
</style>
